import { createContext, useContext } from 'react';

import type { CarouselCollection } from 'bundles/collections-carousel/types/CarouselCollection';

export type EnterpriseSkillsClipsContextType = {
  skillClipsLoading: boolean;
  skillClipsCollections?: CarouselCollection[];
};

const EnterpriseSkillsClipsContext = createContext<EnterpriseSkillsClipsContextType>({
  skillClipsLoading: false,
  skillClipsCollections: [],
});

export const useSkillClipsCollections = () => useContext(EnterpriseSkillsClipsContext);

export default EnterpriseSkillsClipsContext;
